import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { FaMinus, FaPlus, FaTrash, FaArrowLeft } from "react-icons/fa";
import { BsHandbag } from "react-icons/bs";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateSubtotal = () => {
    let subtotal = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        subtotal += price * item.quantity;
      }
    });
    return subtotal;
  };

  const subtotal = calculateSubtotal();
  const shipping = subtotal > 50 ? 0 : 7.99;
  const total = subtotal + shipping;

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleRemoveItem = (id, size, color) => {
    removeFromCart(id, size, color);
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getColorCode = (colorName) => {
    const colorMap = {
      "Ocean Blue": "#1E90FF",
      "Coral Pink": "#FF6B6B",
      "Seafoam Green": "#90EE90",
      "Deep Blue": "#00008B",
      "Sky Blue": "#87CEEB",
      "Classic Red": "#DC143C",
      Coral: "#FF7F50",
      Grey: "#808080",
      White: "#FFFFFF",
      Navy: "#000080",
      Teal: "#008080",
      Sand: "#F4A460",
      Purple: "#800080",
      Blue: "#0000FF",
      Pink: "#FFC0CB",
      Yellow: "#FFD700",
      Black: "#000000",
      Red: "#FF0000",
      Green: "#228B22",
      Orange: "#FFA500",
      Brown: "#8B4513",
      "Dark Grey": "#4A4A4A",
      "Bioluminescent Blue": "#00FFFF",
      Spotted: "#FFFFFF",
      "Golden Brown": "#DAA520",
      Cinnamon: "#D2691E",
      Cream: "#FFFDD0",
      "Forest Green": "#228B22",
      "Red Berries": "#C41E3A",
      "Red Spotted": "#FF0000",
      Rainbow:
        "linear-gradient(90deg, #FF0000, #FF7F00, #FFFF00, #00FF00, #0000FF)",
      Pastel: "linear-gradient(90deg, #FFB6C1, #E6E6FA, #B0E0E6)",
      "Confetti Colors": "linear-gradient(90deg, #FF6B6B, #4ECDC4, #FFE66D)",
      "Birthday Cake Design": "#FF69B4",
      "Gift Box": "#9B59B6",
      "Party Hat": "#3498DB",
      "Red Cap": "#DC143C",
      "Orange Cap": "#FFA500",
      "Purple Cap": "#800080",
      "Multi-colored Ocean Palette":
        "linear-gradient(90deg, #1E90FF, #90EE90, #FF6B6B)",
      "Bold Colors": "linear-gradient(90deg, #FF0000, #0000FF, #FFFF00)",
    };
    if (colorMap[colorName]) return colorMap[colorName];
    return "#CCCCCC";
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <div className="cart-page__empty">
          <div className="empty-cart">
            <div className="empty-cart__icon">
              <BsHandbag />
            </div>
            <h1 className="empty-cart__title">Your bag is empty</h1>
            <p className="empty-cart__text">
              Looks like you haven't added anything yet.
            </p>
            <Link to="/shop" className="empty-cart__btn" onClick={toTop}>
              Continue Shopping
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <div className="cart-page__content">
        <div className="cart-header">
          <h1 className="cart-title">Your Bag</h1>
          <span className="cart-count">
            {cartItems.length} {cartItems.length === 1 ? "item" : "items"}
          </span>
        </div>

        <div className="cart-layout">
          <div className="cart-items">
            <div className="cart-items__header">
              <span>Product Details</span>
              <span>Quantity</span>
              <span>Total</span>
            </div>

            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;

              const itemTotal =
                parseFloat(product.price.replace(/,/g, "")) * item.quantity;

              return (
                <div
                  key={`${item.id}-${item.size}-${item.color}`}
                  className="cart-item"
                >
                  <div className="cart-item__product">
                    <Link
                      to={`/product/${product.id}`}
                      className="cart-item__image-link"
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        className="cart-item__image"
                      />
                    </Link>
                    <div className="cart-item__details">
                      <span className="cart-item__category">
                        {product.category}
                      </span>
                      <Link
                        to={`/product/${product.id}`}
                        className="cart-item__name"
                        onClick={toTop}
                      >
                        {product.name}
                      </Link>
                      <p className="cart-item__meta">
                        <span className="cart-item__option">
                          <span className="cart-item__option-label">
                            Color:
                          </span>
                          <span
                            className="cart-item__color-dot"
                            style={{ background: getColorCode(item.color) }}
                          />
                          {item.color}
                        </span>
                        {item.size &&
                          item.size !== "One Size" &&
                          item.size !== "One Size Set" && (
                            <span className="cart-item__option">
                              <span className="cart-item__option-label">
                                Size:
                              </span>
                              {item.size}
                            </span>
                          )}
                      </p>
                      <p className="cart-item__price">${product.price}</p>
                    </div>
                  </div>

                  <div className="cart-item__quantity">
                    <div className="quantity-selector">
                      <button
                        className="qty-btn"
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                      >
                        <FaMinus />
                      </button>
                      <span className="qty-value">{item.quantity}</span>
                      <button
                        className="qty-btn"
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        <FaPlus />
                      </button>
                    </div>
                    <button
                      className="cart-item__remove"
                      onClick={() =>
                        handleRemoveItem(item.id, item.size, item.color)
                      }
                    >
                      <FaTrash />
                      Remove
                    </button>
                  </div>

                  <div className="cart-item__total">
                    <span className="cart-item__total-value">
                      ${itemTotal.toFixed(2)}
                    </span>
                  </div>
                </div>
              );
            })}

            <div className="cart-items__footer">
              <Link to="/shop" className="continue-shopping" onClick={toTop}>
                <FaArrowLeft />
                Continue Shopping
              </Link>
            </div>
          </div>

          <div className="cart-summary">
            <div className="summary-card">
              <h2 className="summary-title">Order Summary</h2>

              <div className="summary-row">
                <span className="summary-label">Subtotal</span>
                <span className="summary-value">${subtotal.toFixed(2)}</span>
              </div>

              <div className="summary-row">
                <span className="summary-label">Shipping</span>
                <span className="summary-value">
                  {shipping === 0 ? (
                    <span className="free-shipping">Free</span>
                  ) : (
                    `$${shipping.toFixed(2)}`
                  )}
                </span>
              </div>

              {shipping > 0 && (
                <p className="shipping-notice">
                  Free shipping on orders over $50
                </p>
              )}

              <div className="summary-divider" />

              <div className="summary-row summary-row--total">
                <span className="summary-label">Total</span>
                <span className="summary-value">${total.toFixed(2)}</span>
              </div>

              <button className="checkout-btn" onClick={handleCheckout}>
                <BsHandbag className="btn-icon" />
                Proceed to Checkout
              </button>

              <div className="secure-checkout">
                <span className="secure-icon">🔒</span>
                <span>Secure Checkout</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CartPage;
